import {create} from 'zustand';

import {type ActiveRun} from './types';

type IssuesStoreState = {
  activeRun: ActiveRun | null | undefined;
  annotationActive: boolean;
  handleIssueInteraction: (
    event: 'hover' | 'unhover',
    issueId: string | null
  ) => () => void;
  hoveredIssue: string | null;
  selectedIssue: string | null;
  setActiveRun: (activeRun: ActiveRun | null) => void;
  setSelectedIssue: (selectedIssue: string | null) => void;
  toggleIssues: () => void;
};

export const useIssuesState = create<IssuesStoreState>()((set, get) => ({
  hoveredIssue: null,
  selectedIssue: null,
  activeRun: undefined,
  annotationActive: true,
  handleIssueInteraction:
    (event: 'hover' | 'unhover', issueId: string | null) => () => {
      if (event === 'hover') {
        set({hoveredIssue: issueId});
      } else {
        set({hoveredIssue: null});
      }
    },
  setSelectedIssue: (selectedIssue: string | null) => {
    set({selectedIssue});
  },
  setActiveRun: (activeRun: ActiveRun | null) => {
    set({activeRun});
  },
  toggleIssues: () => {
    set({annotationActive: !get().annotationActive});
  },
}));
